import React, {FC, useEffect, useRef, useState} from "react";
import NcModal from "components/NcModal/NcModal";
import SingleCommentForm from "containers/PageSingle/SingleCommentForm";
import { CommentType } from "./CommentCard";
import {collection, doc, increment, updateDoc} from "firebase/firestore";
import {db} from "../../configs/firebase-config";

export interface ModalEditCommentProps {
  comment: CommentType;
  show: boolean;
  onCloseModalEditComment: () => void;
  data: any
}

const ModalEditComment: FC<ModalEditCommentProps> = ({comment, show, onCloseModalEditComment, data}) => {
  const textareaRef = useRef(null);
  const [editedComment, setEditedComment] = useState("");

  const editComment = async (e: any) => {
    e.preventDefault();
    const postDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}`);
    const commentCollectionRef = collection(postDocRef, "comments");
    await updateDoc(doc(commentCollectionRef, `${comment.id}`), {content: editedComment});
    onCloseModalEditComment();
  }
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        const element: HTMLTextAreaElement | null = textareaRef.current;
        if (element) {
          (element as HTMLTextAreaElement).focus();
          (element as HTMLTextAreaElement).setSelectionRange(
            (element as HTMLTextAreaElement).value.length,
            (element as HTMLTextAreaElement).value.length
          );
        }
      }, 400);
    }
  }, [show]);

  const renderContent = () => {
    return (
      <SingleCommentForm
        className="mt-0"
        onClickCancel={onCloseModalEditComment}
        onClickSubmit={async (e) => {
          await editComment(e);
        }}
        onChange={(e) => {setEditedComment(e.target.value)}}
        defaultValue={comment.content}
        textareaRef={textareaRef}
        rows={8}
        children={comment.content}
      />
    );
  };

  const renderTrigger = () => {
    return null;
  };

  return (
    <NcModal
      isOpenProp={show}
      onCloseModal={onCloseModalEditComment}
      contentExtraClass="max-w-screen-md"
      renderContent={renderContent}
      renderTrigger={renderTrigger}
      modalTitle="Editing comment"
    />
  );
};

export default ModalEditComment;
